import Vue from "vue";
import Vuex from "vuex";
import appStore from "@/common/store/app-store";
import userStore from "@/common/store/user-store";
import promoteProjects from "@/drc/store/promote-projects-store";
import searchStore from "@/drc/store/search-filters-store";
import notificationStore from "@/drc/store/notification-store";
import userSavedProjects from "@/drc/store/user-saved-projects-store"
import newSubmissionStore from "@/drc/store/new-submission-store.js";
import projectValidationStore from "@/drc/store/project-validation-store";
import globalSearchStore from "@/drc/store/global-search-store";
import managementFiltersStore from "@/drc/store/management-filters-store";
import userFiltersStore from "@/drc/store/user-dashboard-filters-store";
import sideMenuStore from "@/drc/store/side-menu-store";
import DRCCommonStore from "@/common/store/DRC-common-store";

Vue.use(Vuex);


export default new Vuex.Store({
	strict: process.env.NODE_ENV !== "production",
	modules: {
		appStore,
		userStore,
		notificationStore,
		userSavedProjects,
		newSubmissionStore,
		searchStore,
		projectValidationStore,
		globalSearchStore,
		managementFiltersStore,
		sideMenuStore,
		userFiltersStore,
		DRCCommonStore,
		promoteProjects
	},
});
